import styled from 'styled-components';
import colors from '../../theme/search/colors';

const Wrapper = styled.div`
  padding-top: 8px;

  .row {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;

    @media (max-width: 767px) {
      padding: 13px;
      display: block;
      text-align: center;
      background-color: ${colors.grayNine};
      margin-bottom: 5px;
    }
  }

  input {
    background: transparent;
  }

  .input {
    width: 70%;

    @media (max-width: 767px) {
      width: calc(100% - 26px);
      padding-left: 13px;
      padding-right: 13px;
    }
  }

  .input2 {
    width: 100%;
  }

  .input3 {
    width: 100%;
  }

  .select {
    margin-top: 10px;
    margin-left: 50px;
    min-width: 150px;
    max-width: 295px;

    @media (max-width: 767px) {
      width: 100%;
      min-width: initial;
      max-width: 100%;
      margin-left: 0;
      margin-top: 15px;
    }
  }

  .select2 {
    margin-top: 10px;
    margin-right: 30px;
    max-width: 125px;
    min-width: 125px;

    @media (max-width: 767px) {
      width: 100%;
      margin-right: 0;
      margin-top: 15px;
      margin-bottom: 15px;
    }
  }

  .separator {
    color: ${colors.graySix};
    font-size: 16px;
    font-family: 'Roboto Condensed';
    font-weight: 700;
    line-height: 19px;
    border-bottom: 1px solid ${colors.graySeven};
    padding-bottom: 5px;
    margin-bottom: 17px;
    margin-top: 13px;
    text-transform: uppercase;

    @media (max-width: 767px) {
      border: 0px;
      padding-left: 15px;
      margin-bottom: 8px;
      margin-top: 8px;
    }
  }

  path {
    fill: ${colors.footerLogo};
  }

  .remove-action {
    cursor: pointer;

    @media (max-width: 767px) {
      padding-top: 16px;
    }
  }

  .container-criteria {
    max-width: 1050px;
  }

  .checkbox-zone {
    display: flex;
    width: 100%;
    justify-content: space-between;
    font-size: 15px;

    @media (min-width: 768px) {
      > div {
        width: 33%;
      }

      > div:nth-child(2) {
        padding-left: 35px;
      }
    }

    @media (max-width: 767px) {
      display: block;
      width: calc(100% - 22px);
      margin-left: 11px;
      margin-right: 11px;

      > div {
        padding-bottom: 10px;
      }

      > div:nth-child(3) {
        padding-bottom: 30px;
      }
    }

    & .title {
      text-transform: uppercase;
      font-weight: bold;
      font-family: 'Roboto Condensed';
      font-weight: 700,
      color: ${colors.blackThree};
      text-align: left;
      margin-bottom: 20px;

      @media (max-width: 767px) {
        margin-top: 20px;
        margin-bottom: 16px;
      }
    }
  }

  .button-search-zone {
    display: flex;
    justify-content: center;
  }

  .button-container-search {
    padding-bottom: 30px;
    display: flex;
    justify-content: space-between;
    width: calc(100% - 50px);
    max-width: 1000px;

    @media (max-width: 767px) {
      width: calc(100% - 22px);
      display: block;
      margin-left: 11px;
      margin-right: 11px;

      > div:nth-child(2) {
        padding-top: 17px;
      }
    }
  }

  .hr {
    @media (max-width: 767px) {
      margin-top: 11px;
      margin-bottom: 11px;
    }
  }
`;

const svgStyle = {
  width: 20,
  margin: 10,
  marginTop: 15
};

export { Wrapper, svgStyle };



// WEBPACK FOOTER //
// ./src/pages/AdvancedSearch/style.js